import {Component, OnInit, Inject, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AppService} from '@irb/app.service';
import {ModelsService} from '../models-new/models.service';
import {IrbAppEvents} from '@irb/app.events';
import {IModel, IModelDelete, IModelReplaceSecurity} from '@irb/irb-clients/irb-clients.model';
import {IAlertDialogData} from '@irb/app.model';
import {IDropdownItem} from '@irb/irb-common/models/dropdown.model';
import {IrbEditorsService} from '@irb/irb-editors/irb-editors.service';
import {UtilityService} from '@irb/irb-common/services/utility.service';
import {DropdownFilterComponent} from '@irb/irb-common/components/dropdown-filter/dropdown-filter.component';

@Component({ standalone: false,
    selector: 'irb-delete-model-dialog',
    templateUrl: './create-replace-security-dialog.component.html',
    styleUrls: ['./create-replace-security-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class CreateReplaceSecurityDialogComponent implements OnInit {
    @ViewChild('securitiesDropdown') securitiesDropdown: any;
    securitiesList: any;
    replaceSecurityModels: Array<any>;
    //assignedToNoOfReplaceSecurityBlendedModels: boolean = true;
    @ViewChild('IrbDropdownReplaceWithSecurity') IrbDropdownReplaceWithSecurity: any;
    public selectedModelSecurity: Array<IDropdownItem> = [];
    selectedModelSecurityval: any;
    replaceThisSecurity: any;
    withThisSec: any;
    replaceThisSecurityValue: any;
    replaceSecurityContinueFunction: Function;
    canNotReplaceSecurity: boolean = true;

    constructor(public dialogRef: MatDialogRef<CreateReplaceSecurityDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public mdd: any,
                private as: AppService,
                private modelService: ModelsService,
                private util: UtilityService,
                private ies: IrbEditorsService) {
    }

    ngOnInit(): void {
        this.replaceSecurityModels = this.mdd.replaceSecurityModels.selectedIds as Array<IModel>;
        this.replaceSecurityContinueFunction = this.mdd.replaceSecurityContinueFunction || null;
        this.checkModelType(this.replaceSecurityModels);
        this.getSelectedModelDropdownValue(this.replaceSecurityModels);
    }

    checkModelType(modelType: Array<any>) {
        let checkBlendedModel = true;
        let isSubscribeModelExists = false;
        for (let i = 0; i < modelType.length; i++) {
            if (modelType[i].typeModel === "Blended") {
                checkBlendedModel = false;
            } else {
                if (modelType[i].isSubscribed)
                    isSubscribeModelExists = true;
            }
        }
        if (!checkBlendedModel) {
            this.allReplaceSecurityBlendedOrSubscribeAlert();
        } else {
            if (isSubscribeModelExists)
                this.allReplaceSecurityBlendedOrSubscribeAlert('subscribed');
        }

    }

    getsecurityDropdown(searchStr: any) {
        if (!searchStr || (searchStr && searchStr.trim() === '')) {
            this.securitiesDropdown.set([]);
            return;
        }
        const sortByKey = this.util.sortByKey;
        this.ies.getSecuritiesSearchDropDown(searchStr).subscribe((data: any) => {
            sortByKey(data.items, "securitySymbol", "asc");
            this.securitiesDropdown.set(data.items);
        });
    }

    getSelectedModelDropdownValue(modelType: any) {
        var selectedModelDropdownVal = [];
        for (let i = 0; i < modelType.length; i++) {
            selectedModelDropdownVal.push(
                modelType[i].modelId,
            )

        }
        const sortByKey = this.util.sortByKey;
        this.modelService.getSecuritiesOfSelectedModel(selectedModelDropdownVal).subscribe((data: any) => {
            sortByKey(data.items, "name", "asc");
            data.items.forEach((item: any) => {
                this.selectedModelSecurity.push({
                    name: item.name,
                    value: item.id
                } as IDropdownItem);
            });
        });
    }

    getSelectedList(searchStr: string) {
        this.IrbDropdownReplaceWithSecurity.set(DropdownFilterComponent.getFilteredList(searchStr, this.selectedModelSecurity));
    }

    onSecuritiesChange(s: Array<IDropdownItem>) {
        this.securitiesList = s;
        this.onInputChange();
    }

    getSelectedSecurityModelDropdownValue(item: IDropdownItem) {
        this.selectedModelSecurityval = item;
        this.onInputChange();
    }

    allReplaceSecurityBlendedOrSubscribeAlert(modelType: string = 'blended') {
        this.close();
        let blendedErrorMsgTitle = "Securities cannot be replaced within blended models.";
        let blendedErrorMessage = "Deselect the blended models to perform this operation.";
        if (modelType === 'subscribed') {
            blendedErrorMsgTitle = "Securities cannot be replaced within subscribed models.";
            blendedErrorMessage = "Deselect the subscribed models to perform this operation.";
        }
        this.as.fireEvent(IrbAppEvents.SHOW_ALERT, {
            dTitle: "Replace a security",
            dType: 'ERROR',
            msg: blendedErrorMsgTitle,
            altMsg: blendedErrorMessage,
            dProceedBtnLabel: "Close"
        } as IAlertDialogData);
    }

    close() {
        if (this.dialogRef.close != undefined)
            this.dialogRef.close();
    }

    replaceSecurity() {
        this.replaceThisSecurityValue = Number(this.selectedModelSecurityval.value);
        this.replaceThisSecurity = {
            [this.replaceThisSecurityValue]: this.selectedModelSecurityval.name,
        };
        this.withThisSec = {
            [this.securitiesList.value]: this.securitiesList.name
        }
        const req = {
            modelDTOList: this.replaceSecurityModels,
            replaceThisSecurity: this.replaceThisSecurity,
            withThisSecurity: this.withThisSec
        } as IModelReplaceSecurity;
        this.modelService.replacesecurity(req).subscribe((data: any) => {
            this.replaceSecurityContinueFunction(data);
            this.as.fireEvent(IrbAppEvents.HIDE_WAIT);
            if (data.data === "success") {
                this.as.fireEvent(IrbAppEvents.SHOW_TOAST, {
                    severity: "success",
                    summary: "Save",
                    detail: "Model updated."
                });
                this.as.fireEvent(IrbAppEvents.GRID_REFRESH);
            }
            this.close();
        });
    }

    onInputChange() {
        if (this.selectedModelSecurityval !== undefined && this.securitiesList !== undefined) {
            this.canNotReplaceSecurity = false;
        }
        if (this.selectedModelSecurityval !== undefined && this.securitiesList === undefined) {
            this.canNotReplaceSecurity = true;
        }
        if (this.selectedModelSecurityval === undefined && this.securitiesList !== undefined) {
            this.canNotReplaceSecurity = true;
        }
    }

    clearReplaceSecurity() {
        this.securitiesList = undefined;
        this.canNotReplaceSecurity = true;
    }
}
